import React from "react";
import Avatar from "@mui/material/Avatar";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { getIconColor, getIconComponent } from "../../../../utils/merchant";
import { DESIGN_TOKENS } from "../../../../types/order";

const OrderMerchantAvatar = ({
  channelMerchant,
  foodTypeIcon,
  theme,
  isMobile = false,
}) => {
  const MerchantIcon = getIconComponent(foodTypeIcon || "RestaurantIcon");
  const iconColor = getIconColor(foodTypeIcon || "RestaurantIcon");
  const size = isMobile
    ? DESIGN_TOKENS.avatarSize.sm
    : DESIGN_TOKENS.avatarSize.md;
  const iconSize = isMobile
    ? DESIGN_TOKENS.iconSize.md - 2
    : DESIGN_TOKENS.iconSize.md;

  const getInitials = (name) => {
    const defaultValue = "N/A";

    if (!name) {
      return defaultValue;
    }

    const initials = name
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase())
      .join("")
      .substring(0, 2);

    return initials;
  };

  const merchantName = channelMerchant || "Merchant não definido";
  const initials = getInitials(channelMerchant);

  const avatarContent = foodTypeIcon ? (
    <MerchantIcon sx={{ fontSize: iconSize, color: "#FFFFFF" }} />
  ) : (
    <Typography
      sx={{
        fontSize: isMobile
          ? DESIGN_TOKENS.fontSize.xs
          : DESIGN_TOKENS.fontSize.sm,
        fontWeight: 600,
      }}
    >
      {initials}
    </Typography>
  );

  return (
    <Tooltip title={merchantName}>
      <Avatar
        sx={{
          width: size,
          height: size,
          bgcolor: iconColor,
          color: "#FFFFFF",
          boxShadow: isMobile ? theme.shadows[1] : theme.shadows[2],
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        aria-label={`Merchant: ${merchantName}`}
      >
        {avatarContent}
      </Avatar>
    </Tooltip>
  );
};

export default React.memo(OrderMerchantAvatar);
